var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoneCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8A7.75 7.75 0 11.25 8a7.75 7.75 0 0115.5 0zm-8.646 4.104l5.75-5.75a.5.5 0 000-.708l-.707-.707a.5.5 0 00-.708 0L6.75 9.63l-2.19-2.19a.5.5 0 00-.706 0l-.708.707a.5.5 0 000 .708l3.25 3.25a.5.5 0 00.708 0z",
    fill: "#6ABAA4"
  })));
}

export default __webpack_public_path__ + "./fonts/done-check.0024e60f32d8b836176f77e87dfdb20e.svg";
export { SvgDoneCheck as ReactComponent };